/**
 * сюда класть полифиллы которые нужны всем сервисам,
 * если что-то требуется только одному сервису 
 * - лучше прописать конкретно к нему в polyfills.ts 
 * (чтобы не раздувать бандл всем)
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).globalThis = window;

import 'web-streams-polyfill/polyfill';
// требует global-this
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
